import axios from "axios";
import { api } from "./api_route";

export const createRespondentAdministratorAPI = async (
  respondentAdministratorData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      respondentAdministratorData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/respondentAdministrator/create`,
      respondentAdministratorData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getRespondentAdministratorByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(
      `${api}/respondentAdministrator/case/${caseID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateRespondentAdministratorAPI = async (
  respondentAdministratorID,
  respondentAdministratorData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      respondentAdministratorData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/respondentAdministrator/update/${respondentAdministratorID}`,
      respondentAdministratorData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteRespondentAdministratorAPI = async (
  respondentAdministratorID,
) => {
  try {
    const response = await axios.delete(
      `${api}/respondentAdministrator/delete/${respondentAdministratorID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteRespondentAdministratorDocumentAPI = async (documentID) => {
  try {
    const response = await axios.delete(
      `${api}/respondentAdministrator/document/delete/${documentID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const respondentAdministratorDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/respondentAdministratorDocuments/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};
// Document Categories Constants
export const RESPONDENTADMINISTRATOR_DOCUMENT_CATEGORIES = {
  AUTHORIZATIONLETTER: 1244,
};

export const DOCUMENT_CATEGORY_LABELS = {
  1244: "AuthorizationLetter",
};
